export const knowledgeBase = "docs.intelligems.io";
export const uninstallIntelligems =
  "docs.intelligems.io/faqs/general-faqs#how-do-i-uninstall-intelligems";
export const bookDemo = "intelligems.io/demo-request";
// Hubspot Docs
//#region -- Price Testing
export const checkoutScript =
  "docs.intelligems.io/getting-started/pricing-integration-guides/integration-guide-for-shopify-plus/step-3-add-the-checkout-script";
export const priceTestSetup =
  "docs.intelligems.io/price-testing/how-to-set-up-a-price-test";
export const priceTestPriceSetup =
  "docs.intelligems.io/price-testing/how-to-set-up-a-price-test#step-5-set-the-test-prices";
export const intelligemsWizardPriceTest =
  "docs.intelligems.io/price-testing/starting-a-price-test";
export const endPriceTest =
  "docs.intelligems.io/price-testing/ending-a-price-test";
export const priceShopPlusIntegration =
  "docs.intelligems.io/getting-started/pricing-integration-guides/integration-guide-for-shopify-plus";
export const priceFunctionsIntegration =
  "docs.intelligems.io/getting-started/pricing-integration-guides/integration-guide-using-shopify-functions";
export const priceNonPlusIntegration =
  "docs.intelligems.io/getting-started/pricing-integration-guides/integration-guide-for-shopify-advanced-shopify-and-shopify-basic";
export const subscriptionProductTesting =
  "docs.intelligems.io/price-testing/testing-with-subscriptions";
export const updateCart =
  "docs.intelligems.io/getting-started/pricing-integration-guides/integration-guide-for-shopify-plus/step-4-update-your-cart";
export const activateProducts =
  "docs.intelligems.io/getting-started/pricing-integration-guides/integration-guide-for-shopify-advanced-shopify-and-shopify-basic/step-4-configure-duplicate-products";
export const nonPlusJavascriptIntegration =
  "docs.intelligems.io/getting-started/pricing-integration-guides/integration-guide-for-shopify-advanced-shopify-and-shopify-basic/step-1-add-intelligems-javascript";
export const plusJavascriptIntegration =
  "docs.intelligems.io/getting-started/pricing-integration-guides/integration-guide-for-shopify-plus/step-1-add-intelligems-javascript";
export const multiCurrencyTesting =
  "docs.intelligems.io/price-testing/multi-currency-testing";
export const priceTestIntegrationGettingStarted =
  "docs.intelligems.io/getting-started/pricing-integration-guides";
export const priceTestQaChecklist =
  "docs.intelligems.io/price-testing/price-test-qa-checklist";
export const priceTestPriceTagging =
  "docs.intelligems.io/getting-started/price-testing-integration-guides/integration-guide-using-checkout-scripts/step-2-tag-product-prices";

//#endregion --
//#region -- Shipping Testing
export const intelligemsRateShippingTest =
  "docs.intelligems.io/shipping-testing/starting-a-shipping-test";
export const shippingTestSetup =
  "docs.intelligems.io/shipping-testing/shipping-testing-getting-started";
export const endShippingTest =
  "docs.intelligems.io/shipping-testing/ending-a-shipping-test";
export const shippingProgressBar =
  "docs.intelligems.io/shipping-testing/shipping-progress-bar-integration";
export const shippingTestQaChecklist =
  "docs.intelligems.io/shipping-testing/shipping-test-qa-checklist";
//#endregion --
//#region -- General Testing
export const allIntegrationGuides =
  "docs.intelligems.io/getting-started/adding-intelligems-script-to-your-theme";
export const testDesignBestPractices =
  "docs.intelligems.io/getting-started/best-practices/test-design-best-practices";
export const testIdeas = "docs.intelligems.io/getting-started/test-suggestions";
export const bestPracticesDuringTest =
  "docs.intelligems.io/getting-started/best-practices/best-practices-during-a-test";
export const audienceTargeting =
  "docs.intelligems.io/content-testing/targeting/audience-targeting";
export const pauseTest =
  "docs.intelligems.io/faqs/a-b-testing-faqs#i-need-to-edit-something-in-my-live-test-how-do-i-do-that";
export const cookieTargeting =
  "docs.intelligems.io/content-testing/targeting/audience-targeting#custom-audiences";
//#endregion --
//#region -- Campaigns --
export const campaignSetup =
  "docs.intelligems.io/experiences/how-to-set-up-campaign-tests-in-the-app";
export const campaignTestSetup =
  "docs.intelligems.io/experiences/how-to-set-up-campaign-tests-in-the-app";
export const campaignProgressBarSetup =
  "docs.intelligems.io/experiences/integration-guide-adding-the-intelligems-experiences-progress-bar";
export const campaignCheckoutScript =
  "docs.intelligems.io/experiences/launching-your-first-campaign-on-your-shopify-store";
export const campaignMultiFunction =
  "docs.intelligems.io/experiences/running-a-large-number-of-experiences-with-shopify-functions";
export const quantityButtonSetup =
  "docs.intelligems.io/experiences/integrating-the-intelligems-experiences-quantity-buttons";
//#endregion ---
//#region -- Content Testing --
export const contentTestSetup =
  "docs.intelligems.io/content-testing/content-testing-getting-started";
export const urlMatchingExplanation =
  "docs.intelligems.io/content-testing/targeting";
export const pageRedirects =
  "docs.intelligems.io/content-testing/how-to-set-up-a-content-test/how-to-set-up-a-page-redirect-test";
export const templateRedirects =
  "docs.intelligems.io/content-testing/how-to-set-up-a-content-test/how-to-set-up-a-template-test";
export const themeRedirect =
  "docs.intelligems.io/content-testing/how-to-set-up-a-content-test/how-to-set-up-a-theme-test";
export const findReplaceLink =
  "docs.intelligems.io/content-testing/find-and-replace";
export const cssJsLink =
  "docs.intelligems.io/content-testing/css-and-javascript-injection";
export const momofukuCaseStudy =
  "intelligems.io/resources/customer-stories/how-momofuku-used-intelligems-to-test-their-black-friday-offer";
export const lauraGellerCaseStudy =
  "intelligems.io/resources/customer-stories/how-laura-geller-used-automatic-discounts-to-boost-promo-profit-by-17";
export const nurtureAndCaseStudy =
  "intelligems.io/resources/customer-stories/how-nurture-eliminated-discount-code-leakage-in-under-30-minutes";
export const addTemplateSnippet =
  "docs.intelligems.io/developer-resources/intelligems-theme-snippets#template-testing-snippet";
export const contentTestQaChecklist =
  "docs.intelligems.io/content-testing/content-test-qa-checklist";
export const endingThemeTest =
  "docs.intelligems.io/content-testing/ending-a-theme-test";
//#endregion
//#region -- Analytics
export const dataExport =
  "docs.intelligems.io/analytics/exporting-experiment-data";
export const profitAnalysis =
  "docs.intelligems.io/analytics/how-to-add-profit-to-intelligems-analytics";
//#endregion --
//#region -- Hubspot Category Links
export const introductionToIntelligems = "docs.intelligems.io";
export const priceIntegrationDocs = "docs.intelligems.io/price-testing";
export const shippingTesting = "docs.intelligems.io/shipping-testing";
export const contentTesting = "docs.intelligems.io/content-testing";
export const campaignTesting =
  "docs.intelligems.io/experiences/experiences-getting-started";
export const analyzingResults =
  "docs.intelligems.io/analytics/analytics-overview";
//#endregion
//#region -- Targeting
export const marketCurrencyTarget =
  "docs.intelligems.io/content-testing/targeting";
export const targeting = "docs.intelligems.io/content-testing/targeting";
export const mutuallyExclusiveTests =
  "docs.intelligems.io/content-testing/targeting/mutually-exclusive-experiments";
//#endregion
//#region -- Makeswift
export const pricingPage = "intelligems.io/pricing";
export const volumeDiscountLP = "intelligems.io/products/experiences";
//#endregion --
//#region -- Shopify
export const appListing =
  "apps.shopify.com/intelligems?utm_source=login&utm_medium=app";
export const carrierServices =
  "help.shopify.com/en/manual/shipping/setting-up-and-managing-your-shipping/enabling-shipping-carriers";
//#endregion
//#region -- Performance
export const igDirectScriptAdd =
  "docs.intelligems.io/getting-started/integration-guides/adding-intelligems-script-to-your-theme#option-1-add-to-your-theme-code";
//#endregion
//#region -- Personalizations
export const personalizationsGettingStarted =
  "docs.intelligems.io/personalizations/personalizations-getting-started";
export const targetingPersonalizations =
  "docs.intelligems.io/personalizations/targeting-personalizations#audience-targeting";
export const personalizationUrlRedirects =
  "docs.intelligems.io/personalizations/setting-up-personalization-modifications#url-redirects";
export const personalizationThemeRedirects =
  "docs.intelligems.io/personalizations/setting-up-personalization-modifications#theme-changes";
export const personalizationTemplateRedirects =
  "docs.intelligems.io/personalizations/setting-up-personalization-modifications#template-changes";
export const personalizationContentEdits =
  "docs.intelligems.io/personalizations/setting-up-personalization-modifications#content-edits";
export const personalizationOnsiteInjections =
  "docs.intelligems.io/personalizations/setting-up-personalization-modifications#styles-and-javascript";
export const personalizationUnsavedChangesPreview =
  "docs.intelligems.io/personalizations/previewing-personalizations#step-1-save-your-changes";
export const personalizationPriceModGetStarted =
  "docs.intelligems.io/personalizations/setting-up-personalization-modifications#price-changes";
export const personalizationOffersPromotions =
  "docs.intelligems.io/personalizations/setting-up-personalization-modifications/offer-modifications#promotions";
export const personalizationOffersGwp =
  "docs.intelligems.io/personalizations/setting-up-personalization-modifications/offer-modifications#gift-with-purchase";
export const personalizationOffersVolumeDiscount =
  "docs.intelligems.io/personalizations/setting-up-personalization-modifications/offer-modifications#volume-discounts";
//#endregion
export const blackFridayStatus =
  "docs.intelligems.io/faqs/missing-orders-and-visitors-friday-11-24-black-friday";
